import validator from "validator";
import { z } from "zod";

function validateUrl({ url, https }: { url: string; https: boolean }) {
  try {
    return validator.isURL(url, { protocols: https ? ["https"] : undefined });
  } catch (e) {
    return false;
  }
}

// clean input and then check its valid
export const url = ({ errmsg, https }: { errmsg?: string; https: boolean }) =>
  z
    .string()
    .refine((url) => validateUrl({ url, https }), errmsg || "Invalid url");
